import type { FaireProductEntity } from "../../entity_types/product";

export const p_37k3k2fctp: FaireProductEntity = {
  token: "p_37k3k2fctp",
  type: "product",
  name: "Cotton Pocket Tee - Teton",
  brandToken: "b_qba2f8n5gh",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/1aa255c2bee9d5931e04d496e1cdf1833d0213fddd5977c7f62bef266377d3f8.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6234d8df4be708cc50c6cc008703a46ea21ba6fa8c134b8471726505b684ed29.jpeg",
    "https://cdn.faire.com/fastly/bf4dfd5a93d1cffa789c0c60121d7ac4e6e22191da0ae6e9859bda98107671d2.jpeg",
    "https://cdn.faire.com/fastly/bfa958b808a48594612e971c2e30df3a5684827e7399068daa10be3305c3c0ec.jpeg",
    "https://cdn.faire.com/fastly/781d721735e86f3548bfdf14bc2f2fa13914f37a498cf49bec1f2bdb907ddc46.jpeg",
    "https://cdn.faire.com/fastly/388c1ab456fd617d9d1486d369ace95ff9b09e833ba97e9d36baa4278c36a7f8.jpeg",
    "https://cdn.faire.com/fastly/ea388ef5abdd0ebfd229ec3017a05559466d97018d0162579ff75d0c90f54789.png",
    "https://cdn.faire.com/fastly/6687e578fd13cca589718e2a8f5824ab19740fe825853c648c2f8df98736d5c2.png",
  ],
  priceDollars: 15.25,
  description:
    "Drama-free dressing.\n\nFeaturing a snap neckline for easy outfit changes, this super-soft tee is sure to become a wardrobe staple.\n\n * PREMIUM KNIT FABRIC - cotton pocket tees are made from ultra-soft material. Both lightweight and breathable, the premium fabric keeps you cool and comfortable. \n * BONUS FEATURES – Our cotton pocket tees feature a snap neckline, a pocket detail and a classic, cozy fit. Available in sizes 0-3m through 5T. \n * TRENDY, HIGH-QUALITY DESIGNS – At Copper Pearl, we pride ourselves on making high quality products that always look great on babies and toddlers, moms, or in your nursery. Our cotton pocket tees are simple, modern, and sure to elevate your style.",
  tags: [],
  msrpDollars: 30.49,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:27:18.584Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
